module.exports = __webpack_public_path__ + "7f8cf4a4ab69f1c06271f77d3b37f3e2.png";


//////////////////
// WEBPACK FOOTER
// ./pages/news/8/DMEXCO_web_news.png
// module id = 249
// module chunks = 0